<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>党费系统</el-breadcrumb-item>
        <el-breadcrumb-item>缴费管理</el-breadcrumb-item>
        <el-breadcrumb-item>缴费设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <div class="payment-setting">
        <h1 style="line-height: 50px;color: green;">请设置缴费截止日期</h1>
        <el-form
          style="width: 70%;margin: auto;"
          :model="listParams"
          label-width="100px">
          <el-form-item label="截止日期" prop="expiration">
            <el-radio v-model="expirationType" :label="6">缴费当月1号起6个月内</el-radio>
            <br/>
            <el-radio v-model="expirationType" :label="0">不限</el-radio>
            <br/>
            <el-radio v-model="expirationType" :label="-1">
              <el-input-number
                :disabled="expirationType !== -1"
                size="small"
                v-model="listParams.expiration"
                :min="1"
                :max="12">
              </el-input-number>
            </el-radio>
          </el-form-item>

          <el-form-item label=" " style="margin-top: 70px;">
            <el-button
              style="width: 160px;"
              size="small"
              type="primary"
              @click="editSetting">
              修改
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
export default {
  data () {
    return {
      expirationType: 0,
      listParams: {
        expiration: ''
      }
    };
  },
  mounted () {
    this.loadSetting();
  },
  methods: {
    /**
       * 加载缴费设定
       */
    loadSetting () {
      Vue.ajaxGet(this, global.apiUrl + '/partyFee/endMonth', {}).then((res) => {
        if (res !== 0 && res !== 6) {
          this.expirationType = -1;
          this.listParams.expiration = res;
        } else {
          this.expirationType = res;
        }
      });
    },
    /**
       * 编辑缴费设定
       */
    editSetting () {
      let expiration = '';
      if (this.expirationType === 0 || this.expirationType === 6) {
        expiration = this.expirationType;
      } else {
        expiration = this.listParams.expiration;
      }
      Vue.ajaxPost(this, global.apiUrl + '/partyFee/endMonth', { expiration: expiration }).then((res) => {
        this.$message.success(res.info);
        this.loadSetting();
      });
    }
  },
  watch: {
    expirationType: function (val, oldVal) {
      if (val !== -1) {
        this.listParams.expiration = 1;
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .home-container{
    .payment-setting{
      width: 500px;
      height: 300px;
      border-radius: 5px;
      margin: 10px auto;
      background-color: #d1d1d1;
      text-align: center;
    }
  }
  .el-radio{
    position: absolute;
    left: 0;
    line-height: 40px;
  }
  .el-button--small{
    position: absolute;
    left: 0;
  }
</style>
